import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Message from '../components/Message'
import Loader from '../components/Loader'
import { listMyOrders } from '../actions/orderActions'
import { LinkContainer } from 'react-router-bootstrap'

const OrderListScreen = ({ history }) => {
  const dispatch = useDispatch()

  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  useEffect(() => {
    if (!userInfo) {
      history.push('/login')
    } else {
      dispatch(listMyOrders())
    }
  }, [history, userInfo, dispatch])

  const orderList = useSelector((state) => state.orderList)
  const { loading, error, orders } = orderList

  return (
    <>
      <h3>My Orders</h3>
      {loading ? (
        <Loader />
      ) : error ? (
        <Message variant='danger'>{error}</Message>
      ) : (
        <table className='table table-striped table-responsive table-hover table-sm'>
          <thead>
            <tr>
              <th>ID</th>
              <th>TOTAL</th>
              <th>PAID</th>
              <th>DELIVERED</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order) => (
              <tr key={order.order_id}>
                <td>{order.order_id}</td>
                <td>{order.total_price}</td>
                <td>{order.is_paid ? 'Paid' : 'Unpaid'}</td>
                <td>{order.is_delivered ? 'Delivered' : 'Not Delivered'}</td>
                <td>
                  <LinkContainer to={`/order/${order.order_id}`}>
                    <button className='btn btn-dark btn-sm'>Details</button>
                  </LinkContainer>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  )
}

export default OrderListScreen
